module.exports = __webpack_public_path__ + "img/invitation1.9550f5cc.png";